module.exports = __webpack_public_path__ + "static/katarzyna-greczka-boldare-ab2ac4649afb35fd5363bce237e029ba.png";